import { render, staticRenderFns } from "./ReportCardTable.vue?vue&type=template&id=52be5370"
import script from "./ReportCardTable.vue?vue&type=script&lang=ts"
export * from "./ReportCardTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports